import api from './index';

// 分页查询水质数据
export function fetchWaterQualityData(params) {
    // 从 localStorage 获取 token
    const token = localStorage.getItem('token');

    // 如果 token 不存在，抛出错误
    if (!token) {
        throw new Error('用户未登录，token 不存在');
    }

    // 使用 Authorization Bearer token 的方式传递 token
    return api.post('/web/waterdata/page', params, {
        headers: {
            Authorization: `Bearer ${token}` // 将 token 放入 Authorization 请求头
        }
    });
}

//导出水质查询数据
export function exportWaterData(params) {
    // 从api实例获取默认配置（已包含token）
    /*return api.post('/web/waterdata/export', params, {
        headers: {
            // 显式声明请求体类型（避免EasyExcel解析异常）
            'Content-Type': 'application/json',
            // 自动继承api实例中的Authorization头（通过拦截器设置）
        },
        responseType: 'blob', // 接收二进制流
    });*/
    return api.post('/web/waterdata/export', params, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            // 明确要求返回Excel格式
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        // 关键：禁用axios的默认转换
        transformResponse: [(data) => {
            // 如果是IE，可能需要特殊处理
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                return data;
            }
            return data instanceof Blob ? data : new Blob([data]);
        }]
    });
}